import {
  EPromptsGlobalImageVariables,
  EPromptsGlobalVariables,
  EPromptsVariables,
} from 'src/constants'
import { ESettingsPromptFields } from 'src/types'

export const getHighlightVariableForField = (field: ESettingsPromptFields): string[] => {
  const globalImageVars = Object.values(EPromptsGlobalImageVariables)
  const globalTextVars = Object.values(EPromptsGlobalVariables)
  const globalVars = [...globalTextVars, ...globalImageVars]

  switch (field) {
    case ESettingsPromptFields.TRAICY_MENTIONS_REPLY:
      return [EPromptsVariables.COMMON_TRAICY_VARIABLE, ...globalVars]
    case ESettingsPromptFields.TRAICY_FOLLOWED_REPLY:
      return [EPromptsVariables.COMMON_TRAICY_VARIABLE, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_FOLLOWED_REPLY:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_DEFINITION_FOLLOWED_REPLY:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_HASHTAG_REPLY:
      return [EPromptsVariables.REPLY_VARIABLE, ...globalVars]
    case ESettingsPromptFields.TRAICY_REPLY_CHATBOT:
      return [
        EPromptsVariables.CHATBOT_REPLY_VARIABLE,
        EPromptsVariables.IS_IMAGE_INCLUDED,
        EPromptsVariables.TRAICY_CHATBOT_API_RESP_FORMAT,
        ...globalVars,
      ]
    case ESettingsPromptFields.TRAICY_DEFINITION_CHATBOT:
      return [
        EPromptsVariables.CHATBOT_REPLY_VARIABLE,
        EPromptsVariables.IS_IMAGE_INCLUDED,
        EPromptsVariables.TRAICY_CHATBOT_API_RESP_FORMAT,
        ...globalVars,
      ]
    case ESettingsPromptFields.TRAICY_MESSAGE_CHECK:
      return [EPromptsVariables.MENTION_TRAICY_VARIABLE, ...globalVars]
    case ESettingsPromptFields.SCAN_TO_EARN_DEFINITION_MEDIA_VALIDATION:
      return [EPromptsVariables.SCAN_TO_EARN_BARCODE_VARIABLE, ...globalVars]
    case ESettingsPromptFields.SCAN_TO_EARN_DEFINITION_IMPACTS:
      return [EPromptsVariables.SCAN_TO_EARN_IMPACTS_LIST_VARIABLE, ...globalVars]
    case ESettingsPromptFields.SCAN_TO_EARN_ACCOUNT_INFO:
      return [
        EPromptsVariables.SCAN_TO_EARN_ACCOUNT_NAME_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_PRODUCT_NAME_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_PRODUCT_TYPE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_PRODUCT_DESCRIPTION_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LATITUDE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LONGITUDE_VARIABLE,
        ...globalVars,
      ]
    case ESettingsPromptFields.LANGUAGE_TRANSLATION:
      return [
        EPromptsVariables.LANGUAGE_TO_TRANSLATE,
        EPromptsVariables.VALUE_TO_TRANSLATE,
        ...globalVars,
      ]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_2:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_3:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_4:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_DEFINITION:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_DEFINITION_2:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_DEFINITION_3:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.TRAICY_IMAGE_WITH_TEXT_DEFINITION_4:
      return [EPromptsVariables.TWEET_GENERATED_TEXT, ...globalVars]
    case ESettingsPromptFields.MAIN_ENTITIES_DESCRIPRIONS_DEFINITION:
      return [
        EPromptsVariables.ENTITY_DESCRIPRION_PROMPT,
        EPromptsVariables.LANGUAGE_CODE,
        EPromptsVariables.USER_PROMPT,
        ...globalVars,
      ]
    case ESettingsPromptFields.MAIN_ENTITIES_DESCRIPRIONS:
      return [
        EPromptsVariables.ENTITY_DESCRIPRION_PROMPT,
        EPromptsVariables.LANGUAGE_CODE,
        EPromptsVariables.USER_PROMPT,
        ...globalVars,
      ]
    case ESettingsPromptFields.SCAN_TO_EARN_DEFINITION_PRODUCT_TYPE:
      return [
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LATITUDE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LONGITUDE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_BARCODE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_ACCOUNT_NAME_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_PRODUCT_NAME_VARIABLE,
        ...globalVars,
      ]
    case ESettingsPromptFields.SCAN_TO_EARN_PRODUCT_TYPE:
      return [
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LATITUDE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_SCANNER_LONGITUDE_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_ACCOUNT_NAME_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_PRODUCT_NAME_VARIABLE,
        EPromptsVariables.SCAN_TO_EARN_BARCODE_VARIABLE,
        ...globalVars,
      ]
    case ESettingsPromptFields.TG_BOT_APPROVED_SCANS_DAILY_SUMMARY_MESSAGE:
      return [EPromptsVariables.TG_BOT_APPROVED_SCANS_COUNT]
    case ESettingsPromptFields.TG_BOT_APPROVED_SCAN_MESSAGE:
      return [
        EPromptsVariables.TG_BOT_ACCOUNT_NAME,
        EPromptsVariables.TG_BOT_PRODUCT_NAME,
        EPromptsVariables.TG_BOT_BARCODE,
        EPromptsVariables.TG_BOT_USER_NAME,
        EPromptsVariables.TG_BOT_PRODUCT_TYPE,
        EPromptsVariables.TG_BOT_USER_TX_LINK,
        EPromptsVariables.TG_BOT_COUNTRY_FLAG,
      ]
    case ESettingsPromptFields.TRACKFI_DEFINITION_STRUCTURED_DATA:
      return [EPromptsVariables.TWEET_TEXT, ...globalVars]
    case ESettingsPromptFields.TRACKFI_STRUCTURED_DATA:
      return [EPromptsVariables.TWEET_TEXT, ...globalVars]
    case ESettingsPromptFields.TRACKFI_DEFINITION_FOLLOWED_REPLY:
      return [
        EPromptsVariables.TWEET_TEXT,
        EPromptsVariables.TRADE_SETUPS,
        EPromptsVariables.USER_HANDLE,
        ...globalVars,
      ]
    case ESettingsPromptFields.TRACKFI_FOLLOWED_REPLY:
      return [
        EPromptsVariables.TWEET_TEXT,
        EPromptsVariables.TRADE_SETUPS,
        EPromptsVariables.USER_HANDLE,
        ...globalVars,
      ]
    case ESettingsPromptFields.TRACKFI_DEFINITION_QUOTE_REPLY:
      return [EPromptsVariables.REPLY_TWEET_TEXT, EPromptsVariables.USER_HANDLE, ...globalVars]
    case ESettingsPromptFields.TRACKFI_QUOTE_REPLY:
      return [EPromptsVariables.REPLY_TWEET_TEXT, EPromptsVariables.USER_HANDLE, ...globalVars]

    case ESettingsPromptFields.JOURNEY_DEFINITION_AI_SEARCH:
      return [EPromptsVariables.SEARCH_TEXT, ...globalVars]
    case ESettingsPromptFields.JOURNEY_AI_SEARCH:
      return [EPromptsVariables.SEARCH_TEXT, ...globalVars]
    default:
      return [...globalVars]
  }
}
